import { Box, Button, DialogTitle, Grid, styled } from "@mui/material";
import { LOCAL_CONSTANT } from "../Const";

//スタイル
const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
});

export interface LocationTraffic5mcutAndMarketCutApprovalCheck {
    props: {
        requestType: string;
        errorFlag: string;
        handleModalClose: () => void;
    };
}

export const LocationTraffic5mcutAndMarketCutApprovalCheck: React.FC<LocationTraffic5mcutAndMarketCutApprovalCheck> = ({ props }) => {
    //文字列分割関数
    const breakedText = (text: string) => {
        return text.split("\n").map((line, key) => (
            <span key={key}>
                {line}
                <br />
            </span>
        ));
    };

    return (
        <Box>
            {props.requestType === "0" &&
                props.errorFlag === "1" && (
                    <DialogTitle>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_APPROVAL}
                    </DialogTitle>
                )}
            {props.requestType === "0" &&
                props.errorFlag === "2" && (
                    <DialogTitle>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_MARKETCUT_APPROVAL}
                    </DialogTitle>
                )}
            {props.requestType === "0" &&
                props.errorFlag === "3" && (
                    <>
                        <DialogTitle sx={{ paddingBottom: "0px" }}>
                            {
                                LOCAL_CONSTANT.ALERT_MESSAGE
                                    .ALERT_NO_TRAFFIC5MCUT_APPROVAL
                            }
                        </DialogTitle>
                        <DialogTitle sx={{ paddingTop: "0px" }}>
                            {
                                LOCAL_CONSTANT.ALERT_MESSAGE
                                    .ALERT_NO_MARKETCUT_APPROVAL
                            }
                        </DialogTitle>
                    </>
                )}
                {props.requestType === "2" &&
                props.errorFlag === "1" && (
                    <DialogTitle>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_MARKETCUT}
                    </DialogTitle>
                )}
                {props.requestType === "2" &&
                    props.errorFlag === "2" && (
                        <DialogTitle>
                            {breakedText(
                                LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                            )}
                        </DialogTitle>
                    )}
            <Box sx={{ margin: "30px" }}>
                <Grid container spacing={1} alignItems="center">
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", justifyContent: "center" }}
                    >
                        <CancelButton onClick={props.handleModalClose}>
                            閉じる
                        </CancelButton>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default LocationTraffic5mcutAndMarketCutApprovalCheck;
